import React from "react";
import { Container, Card } from "react-bootstrap";

function TermsScreen() {
    return (
        <Container className="mt-5">

                <Card.Body>
                    <h1 className="text-center mb-4">Terms and Conditions</h1>
                    <p style={{ textAlign: "justify" }}>
                        By using this Quote Web App ("Start Blue App") for LS Tractor USA, you acknowledge and agree to the following terms and conditions.
                    </p>
                    <h5><strong>Quote Validity:</strong></h5>
                    <p style={{ textAlign: "justify" }}>
                        Quotes generated by the App are valid until the end of the month from the date of issuance unless otherwise specified. Prices and availability are subject to change without notice.
                    </p>
                    <h5><strong>Non-Binding:</strong></h5>
                    <p style={{ textAlign: "justify" }}>
                        All quotes are non-binding and are subject to final approval by LS Tractor USA. The App does not create any legal obligation for LS Tractor USA to sell products at the quoted prices or under the quoted terms.
                    </p>
                    <h5><strong>Intellectual Property:</strong></h5>
                    <p style={{ textAlign: "justify" }}>
                        The content and information on this App, including but not limited to text, graphics, and user interface, are protected by copyright, trademarks, or other proprietary rights and laws. Use of this content without the express permission of the rightful owner is strictly prohibited.
                    </p>
                    <h5><strong>Accuracy of Information:</strong></h5>
                    <p style={{ textAlign: "justify" }}>
                        While we strive to provide accurate and up-to-date information, we cannot guarantee that all information provided by the App will be accurate at all times. Users are encouraged to verify the final quote details with LS Tractor USA.
                    </p>
                    <h5><strong>Limitation of Liability:</strong></h5>
                    <p style={{ textAlign: "justify" }}>
                        In no event shall LS Tractor USA, its affiliates, officers, directors, employees, or agents be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with your use of the App or any quote generated by the App.
                    </p>
                    <h5><strong>Amendments:</strong></h5>
                    <p style={{ textAlign: "justify" }}>
                        LS Tractor USA reserves the right to modify these terms and conditions at any time without prior notice. Your continued use of the App after any such changes constitutes your acceptance of the new terms and conditions.
                    </p>
                    <h5><strong>Governing Law:</strong></h5>
                    <p style={{ textAlign: "justify" }}>
                        These terms and conditions shall be governed by and construed in accordance with the laws of the state in which LS Tractor USA operates, without giving effect to any principles of conflicts of law.
                    </p>
                    <h5><strong>Contact Information:</strong></h5>
                    <p style={{ textAlign: "justify" }}>
                        For any questions or concerns regarding these terms and conditions, please contact LS Tractor USA through the App's contact form or at the provided customer service contact information.
                    </p>
                </Card.Body>

        </Container>
    );
}

export default TermsScreen;
